import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Pagination from 'components/styled-pagination'
import ProductTile from '../product-tile'
import { getPageStats } from '../../../../../multi-vertical/rate-table/utils'
import styles from './styles.scss'

const FullDashboard = ({ products, paginationProps, ...props }) => {
  const { variation, page, LENDER_PER_PAGE, paginationName } = paginationProps
  const { pageCount, pageFrom, pageTo } = getPageStats(
    variation,
    products,
    page,
    LENDER_PER_PAGE,
  )

  const slicedProducts = products.slice(pageFrom, pageTo)
  const [startAtFirst, setStartAtFirst] = useState(false)

  if (pageFrom > products.length && !startAtFirst) {
    setStartAtFirst(true)
  }
  if (pageFrom === 0 && startAtFirst) {
    setStartAtFirst(false)
  }

  return (
    <div>
      {slicedProducts.map(product => <ProductTile product={product} key={product.uuid} {...props} />)}
      <div className={pageCount > 1 ? styles.paginationContainer : styles.paginationContainerHidden}>
        <Pagination forcePage={startAtFirst ? 0 : undefined} pageCount={pageCount} name={paginationName} />
      </div>
    </div>
  )
}

FullDashboard.propTypes = {
  products: PropTypes.array.isRequired,
  paginationProps: PropTypes.object.isRequired,
}

export default FullDashboard
